<template>
    <div class="flex">
        <a href="#" title="Messages" class="text-base p-4 flex hover:text-yellow-200 text-white"
           @click.prevent="openIt()">
            <i class="fas fa-comment-alt-lines"></i>
        </a>
        <span v-if="unread > 0"
              class="absolute ml-6 items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-600 text-white">
          {{ unread }}
        </span>
        <slideover name="channels" ref="slideover" v-if="typeof user === 'object'"
                   :content-class="'mt-1 px-4 sm:pl-6 sm:pr-0 '+((wideMode && !disableWideMode)?'overflow-y-hidden':'overflow-y-auto') + ' h-full'">
            <template v-slot:title>
                <div class="absolute top-2 z-20 -ml-6 p-2 mt-px left-0.5 transition-opacity duration-500"
                     v-if="!disableWideMode"
                     :class="showWideIcon?'opacity-100':'opacity-0'" @click="toggleWide" @mouseover="mousedOver">
                    <div
                        class="mx-auto flex items-center justify-center h-7 w-7 rounded-full bg-gray-50 border-2 border-gray-300 hover:bg-blue-100">
                        <i id="app-contextual-navigation-desktop-fa" class="fa text-gray-500 text-sm"
                           :class="wideMode?'fa-arrow-right':'fa-arrow-left'"></i></div>
                </div>
                <template v-if="!wideMode || disableWideMode">
                    <div class="flex h-12" v-if='(mode==="channels")' @mouseover="mousedOver">
                        <div class="-mt-1.5 -ml-2">
                            <div class="inline-block text-gray-800 mt-0 pt-1 pb-0.5 px-2">Messages</div>
                            <span class="text-gray-300 text-sm mt-0 ml-2"><span
                                class="far fa-keyboard mr-1"></span>M</span>
                        </div>
                    </div>
                    <div class="flex h-12 overflow-y-visible" v-if='(!wideMode || disableWideMode) && mode==="messages"'
                         @mouseover="mousedOver">
                        <div
                            class="mt-0 -ml-2 mr-4 text-brand font-semibold text-lg h-12 flex items-start sticky sticky-top top:0 z-20 w-full">
                            <button title="Back to Channels" @click="closeWidget"
                                    class="group inline-flex w-[36px] h-[26px] mt-0.5 py-0 cursor-pointer text-lg items-center justify-center rounded-xl hover:bg-gray-100 hover:text-brand-light text-brand right-0">
                                <span class="flex w-[32px] h-[24px] items-center justify-center"><i
                                    class="fas fa-arrow-left"></i>
                                </span>
                            </button>
                            <span class="flex-shrink-0 ml-2 inline-block relative">
                                <message-widget-channel-avatars :contacts="contacts"
                                                                :channel="viewChannel"
                                                                :editMode="editingMembers"
                                                                :disabled="editingChannelName"
                                                                @closed="editingMembers = false"
                                                                @click="editMembers"
                                                                @removed="removeMember"
                                ></message-widget-channel-avatars>
                            </span>
                            <span class="flex ml-2 mr-2 truncate w-full flex-col">
                                <span class="ml-2 mr-2 truncate flex-grow">
                                    <span class="m-0 p-0 tracking-normal w-full whitespace-nowrap"
                                          :class="viewChannel.type==='GROUP'?'cursor-pointer':''"
                                          v-text="viewChannel.name" v-show="!editingChannelName"
                                          @click="goEditGroupName()"></span>
                                    <page-cell class="text-lg tracking-normal border-0 m-0 p-0 w-full"
                                               v-show="editingChannelName" v-model="viewChannel.name" ref="groupname"
                                               @blur="updateGroupName()"></page-cell>
                                </span>
                                <span class="ml-2 text-xs text-gray-400 mr-2 truncate" v-text="lastSeenText"
                                      :key="lastSeenKey"></span>
                            </span>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="flex h-12">
                        <div class="flex max-w-md mr-5 w-full pr-3" style="min-width: 448px">
                            <div class="-mt-1.5 -ml-2">
                                <div class="inline-block text-gray-800 mt-0 pt-1 pb-0.5 px-2">Messages</div>
                                <span class="text-gray-300 text-sm mt-0 ml-2"><span
                                    class="far fa-keyboard mr-1"></span>M</span>
                            </div>
                        </div>
                        <div class="flex-grow pr-4 truncate" v-if="viewChannel">
                            <div
                                class="mt-0 -ml-2 mr-0 truncate text-brand font-semibold text-lg h-12 flex items-start sticky sticky-top top:0 z-20">
                                <span class="ml-2 fixed">
                                    <span class="block relative">
                                        <message-widget-channel-avatars :contacts="contacts"
                                                                        :channel="viewChannel"
                                                                        :editMode="editingMembers"
                                                                        :disabled="editingChannelName"
                                                                        @closed="editingMembers = false"
                                                                        @click="editMembers"
                                                                        @removed="removeMember"
                                        ></message-widget-channel-avatars>
                                    </span>
                                 </span>
                                <span class="flex ml-8 pl-6 mr-0 w-full truncate flex-col">
                                    <span class="ml-2 truncate flex-grow">
                                        <span class="m-0 p-0 tracking-normal w-full whitespace-nowrap"
                                              :class="viewChannel.type==='GROUP'?'cursor-pointer':''"
                                              v-text="viewChannel.name" v-show="!editingChannelName"
                                              @click="goEditGroupName()"></span>
                                        <page-cell class="text-lg tracking-normal border-0 m-0 p-0 w-full"
                                                   v-show="editingChannelName" v-model="viewChannel.name"
                                                   ref="groupname"
                                                   @blur="updateGroupName()"></page-cell>
                                    </span>
                                    <span class="ml-2 text-xs text-gray-400 truncate" v-text="lastSeenText"
                                          :key="lastSeenKey"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <template v-if="!wideMode || disableWideMode">
                <div @mouseover="mousedOver">
                    <message-widget-channels v-show="mode==='channels'"
                                             :user="user"
                                             ref="channels"
                                             :channels="channels"
                                             :contacts="contacts"
                                             :selected="viewChannel.source"
                                             :attachment="attachment"
                                             @createChannel="createChannel"
                                             @updateMessages="updateMessages"
                                             @channelSelected="channelSelected"
                                             @close="close"></message-widget-channels>
                    <message-widget-messages v-if="mode==='messages'"
                                             :user="user"
                                             :channel="viewChannel"
                                             :contacts="contacts"
                                             :attachment="attachment"
                                             @replyingTo="(e) => $emit('replyingTo',e)"
                                             @viewEmail="(e) => $emit('viewEmail',e)"
                                             @messageClicked="(e) => $emit('messageClicked',e)"
                                             ref="messages"
                                             @updateMessages="updateMessages"
                                             @scrollToPosition="scrollToPosition"
                                             @scrollToBottom="scrollToBottom"
                                             :scroll-container="scrollContainer"
                                             @messageSent="scrollPosition = 0; attachment = false"
                                             @close="closeWidget"></message-widget-messages>
                </div>
            </template>
            <template v-else>
                <div class="flex h-full" @mouseover="mousedOver">
                    <div class="overflow-y-scroll mr-2 pr-2 border-r max-w-md h-full" style="min-width: 448px">
                        <message-widget-channels :user="user"
                                                 ref="channels"
                                                 :channels="channels"
                                                 :contacts="contacts"
                                                 :selected="viewChannel.source"
                                                 :attachment="attachment"
                                                 @createChannel="createChannel"
                                                 @updateMessages="updateMessages"
                                                 @channelSelected="channelSelected"
                                                 @close="close"></message-widget-channels>
                    </div>
                    <div class="overflow-y-scroll flex-grow pr-0 h-full" ref="wideMessageParent">
                        <message-widget-messages v-if="viewChannel"
                                                 :key="channelKey"
                                                 :user="user"
                                                 :channel="viewChannel"
                                                 :contacts="contacts"
                                                 :attachment="attachment"
                                                 ref="messages"
                                                 @replyingTo="(e) => $emit('replyingTo',e)"
                                                 @viewEmail="(e) => $emit('viewEmail',e)"
                                                 @messageClicked="(e) => $emit('messageClicked',e)"
                                                 @updateMessages="updateMessages"
                                                 :parent-element="this.$refs.wideMessageParent"
                                                 :scroll-container="scrollContainer"
                                                 @messageSent="scrollPosition = 0; attachment = false"
                                                 @scrollToPosition="scrollToPosition"
                                                 @scrollToBottom="scrollToBottom"
                                                 @close="closeWidget"></message-widget-messages>
                        <div v-else
                             class="h-full flex items-center justify-center text-gray-300 text-lg pb-10 overflow-hidden">
                            <span class="fa fa-arrow-left"></span><span class="ml-2">Please select a channel</span>
                        </div>
                    </div>
                </div>
            </template>
        </slideover>
    </div>
</template>

<script>

import MessageWidgetChannels from "./MessageWidgetChannels.vue";
import MessageWidgetMessages from "./MessageWidgetMessages.vue";
import Slideover from "../../slideovers/Slideover.vue";
import {Message} from "@models";
import User from "../../../services/User";
import {cloneDeep} from "lodash";
import MessageWidgetChannelAvatars from "./MessageWidgetChannelAvatars.vue";
import moment from "moment-timezone";
import remoteStorage from "../../../utils/remoteStorage";
import PageCell from "../../ui/PageCell.vue";

export default {
    components: {
        PageCell, MessageWidgetChannelAvatars, Slideover, MessageWidgetMessages, MessageWidgetChannels
    },
    props: {},
    data() {
        return {
            viewChannel: false,
            channels: [],
            contacts: [],
            scrollPosition: 0,
            mode: 'channels',
            search: '',
            user: Object,
            updateCall: 0,
            messageRefresh: false,
            lastSeenText: '',
            lastSeenKey: 0,
            attachment: false,
            typingTimeout: false,
            hidden: true,
            wideMode: false,
            channelKey: 0,
            showWideIcon: false,
            showWideIconTimeout: false,
            disableWideMode: false,
            scrollContainer: this.$refs.wideMessageParent,
            editingChannelName: false,
            editingMembers: false,
        }
    },
    computed: {
        unread() {
            return this.channels.reduce((a, value) => a + value.unseenReceivedCount, 0)
        },
    },
    methods: {
        async removeMember(handle) {
            this.editingMembers = false
            await Message.removeFromGroup(this.viewChannel.source, handle)
        },
        editMembers() {
            if (this.viewChannel && this.viewChannel.members.find((m) => (m.id === this.user.id) && m.active)) {
                this.editingMembers = true
            }
        },
        goEditGroupName() {
            if (this.viewChannel.type === 'GROUP') {
                this.editingChannelName = true;
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.groupname.$el.focus()
                    })
                })
            }
        },
        updateGroupName() {
            this.editingChannelName = false
            Message.updateGroup(this.viewChannel.source, this.viewChannel.name)
        },
        scrollToPosition(position) {
            if ((!this.disableWideMode) && this.wideMode) {
                this.$refs.wideMessageParent.scrollTop = position
            } else {
                eventBus.$emit('slideover-scroll-to', position)
            }
        },
        scrollToBottom() {
            if ((!this.disableWideMode) && this.wideMode) {
                this.$refs.wideMessageParent.scrollTop = 99999999
            } else {
                eventBus.$emit('slideover-scroll-bottom');
            }
        },
        mousedOver() {
            this.showWideIcon = true;
            clearTimeout(this.showWideIconTimeout);
            this.showWideIconTimeout = setTimeout(() => this.showWideIcon = false, 1200)
        },
        updateScrollcontainer() {
            if (this.hidden) return;
            if (!this.wideMode || this.disableWideMode) {
                this.scrollContainer = this.$refs.slideover.$refs.slideovercontainer
            } else {
                this.scrollContainer = this.$refs.wideMessageParent
            }
            if (!this.scrollContainer) {
                setTimeout(() => this.$nextTick(() => this.updateScrollcontainer()), 50)
            }
        },
        toggleWide() {
            this.wideMode = (!this.disableWideMode) && !this.wideMode
            eventBus.$emit('slideover-set-wide-mode-channels', this.wideMode);
            remoteStorage.setItem('messagingWideMode', JSON.stringify(this.wideMode))
            this.updateScrollcontainer();
        },
        createChannel(data) {
            this.search = data
            this.mode = 'create'
        },
        close() {
            if (!this.hidden) {
                this.hidden = true;
                eventBus.$emit('slideover-close-channels');
            }
        },
        closeWidget(resetSearch = true) {
            this.search = '';
            this.mode = 'channels'
            this.$refs.messages.debouncedSetTyping.cancel();
            User.push('userFinishedTyping')
            this.viewChannel = false;
            if (resetSearch) {
                this.$refs.channels.search = ''
            }
            this.$refs.channels.focusOnSearch()
            this.$nextTick(() => {
                eventBus.$emit('slideover-scroll-to', this.scrollPosition);
            })
        },
        async openIt(data) {
            window.Bus.emit('close-all-slideovers', '-channels');
            eventBus.$emit('slideover-open-channels');
            this.mode = 'channels'
            this.hidden = false;
            await this.updateMessages(data, true)
            this.$nextTick(() => {
                this.$refs.channels.focusOnSearch()
            })
            this.updateScrollcontainer();
        },
        channelSelected(channel, name, source, messageId) {
            this.scrollPosition = this.$refs.slideover.$refs.slideovercontainer.scrollTop;
            if (channel) {
                channel = cloneDeep(channel);
            } else {
                channel = {}
            }
            channel.name = name ? name : channel.name
            channel.source = source ? source : channel.source
            channel.messageId = messageId ? messageId : channel.messageId
            channel.members = channel.members ? channel.members : [];
            if (!channel.avatarUrl && channel.members) {
                if (channel.members.find((i) => i.id == channel.source)) {
                    channel.avatarUrl = channel.members.find((i) => i.id == channel.source).avatarUrl
                }
            }
            this.viewChannel = channel
            this.channelKey++;
            this.mode = 'messages'
            if (this.wideMode) {
                remoteStorage.setItem('messagingWideMode', JSON.stringify(channel.source))
            }
            this.updateLastSeen()
            this.updateScrollcontainer()
        },
        async updateLastSeenFromContactListener(e) {
            let contact = this.contacts.find((i) => i.id === e.aggregate.id)
            if (contact) {
                contact.lastSeenAt = e.data.when
                contact.lastSeenFrom = e.data.ipAddress
                contact.lastSeenAtFormatted = moment(e.data.when).format('lll')
            }
        },
        async updateUserTypingFromContactListener(e) {
            let contact = this.contacts.find((i) => i.id === e.aggregate.id)
            let channel = this.channels.find((i) => i.sourceId === e.data.sourceId)
            if (contact && channel) {
                let existing = channel.lastTyping.find((i) => i.who === contact.id)
                if (existing) {
                    existing.when = e.data.when
                } else {
                    channel.lastTyping.push({who: contact.id, when: e.data.when})
                }
                this.clearExpiredLastTypings()
                this.lastSeenKey++;
            }
        },
        async userFinishedTypingFromContactListener(e) {
            let outstanding = false;
            this.channels.forEach((channel) => {
                channel.lastTyping = channel.lastTyping.filter((i) => i.who !== e.aggregate.id)
                if (channel.lastTyping.length) {
                    outstanding = true;
                }
            })
            if (outstanding) {
                clearTimeout(this.typingTimeout)
                this.typingTimeout = setTimeout(this.clearExpiredLastTypings, 300)
            }
        },
        clearExpiredLastTypings() {
            let outstanding = false;
            this.channels.forEach((channel) => {
                channel.lastTyping = channel.lastTyping.filter((i) => moment().diff(moment(i.when), 'seconds') < 4)
                if (channel.lastTyping.length) {
                    outstanding = true;
                }
            })
            if (outstanding) {
                clearTimeout(this.typingTimeout)
                this.typingTimeout = setTimeout(this.clearExpiredLastTypings, 300)
            }
        },
        async updateMessages(goto = false, clearAttachment = true) {
            if (clearAttachment) {
                this.attachment = false;
            }
            this.channels = await Message.channels()
            window.Bus.emit('messages-unread', this.unread);
            User.registerAggregates(this.channels.map((channel) => {
                return {type: 'Channel', id: channel.id}
            }), this.updateFromChannelListener)
            this.contacts = await Message.contacts()

            User.registerAggregates(this.contacts.map((contact) => {
                return {type: 'User', id: contact.id, 'event': 'userSeen'}
            }), this.updateLastSeenFromContactListener)

            User.registerAggregates(this.contacts.map((contact) => {
                return {type: 'User', id: contact.id, 'event': 'userTyping'}
            }), this.updateUserTypingFromContactListener)

            User.registerAggregates(this.contacts.map((contact) => {
                return {type: 'User', id: contact.id, 'event': 'userFinishedTyping'}
            }), this.userFinishedTypingFromContactListener)

            if (goto) {
                this.updateCall++;
                let channel = this.channels.find((i) => i.source === goto)
                if (!channel) {
                    if (this.updateCall < 5) {
                        setTimeout(() => this.updateMessages(goto), 25 + (100 * this.updateCall))
                        return;
                    }
                } else {
                    this.channelSelected(channel, channel.name, channel.source)
                }
                this.updateCall = 0;
                if (this.$refs.channels) {
                    this.$refs.channels.searchHandles = []
                    this.$refs.channels.search = ''
                    this.$refs.channels.newGroup = ''
                    this.$refs.channels.newMessage = ''
                }
            }
            clearTimeout(this.messageRefresh)
            // update every 9 minutes
            this.messageRefresh = setTimeout(() => this.updateMessages(), 1000 * 60 * 9)
        },
        updateFromChannelListener(data) {
            let channel = Message.make(data.aggregate.data)
            channel.buildChannelTokens()
            Object.assign(this.channels.find((i) => i.id === channel.id), channel)
            this.channels.sort((a, b) => {
                return moment(b.lastMessageDateTime) <= moment(a.lastMessageDateTime) ? -1 : 1
            })
            if ((this.viewChannel.id === channel.id) && (this.$refs.messages)) {
                this.viewChannel.name = channel.name
                this.viewChannel.members = channel.members
                this.viewChannel.handles = channel.handles
                this.$refs.messages.updateMessagesFromEvent(data)
            }
            window.Bus.emit('messages-unread', this.unread);
        },
        updateFromUserListener(data) {
            if (data.event && data.event === 'ChannelCreated') {
                let channel = Message.make(data.data)
                if (!this.channels.some((i) => i.id === channel.id)) {
                    channel.buildChannelTokens()
                    this.channels.unshift(channel)
                    User.registerAggregate({"type": 'Channel', 'id': channel.id}, this.updateFromChannelListener)
                    if (data.data.source === this.viewChannel.source) {
                        this.viewChannel = this.channels[0];
                        this.$nextTick(() => this.$nextTick(() => {
                            this.$refs.messages.updateMessages()
                        }))

                    }
                }
            }
        },
        updateLastSeen() {
            let contact = this.viewChannel ? this.contacts.find((i) => i.id === this.viewChannel.source) : false;
            let text;

            let channel = this.channels.find((i) => i.id === (this.viewChannel ? this.viewChannel.id : false));
            let typing = [];
            if (channel && channel.lastTyping) {
                channel.lastTyping.forEach((i) => {
                    let diff = moment().diff(moment(i.when), 'seconds')
                    if (diff < 4 && (i.who !== this.user.id)) {
                        typing.push(i.who)
                    }
                })
            }
            if (typing.length) {
                let re = typing.map((userId) => {
                    let who = this.viewChannel ? this.viewChannel.members.find((i) => i.id === userId) : false;
                    return who ? who.name : '';
                }).filter((i) => i.trim() !== '')
                text = ((re.length === 2) ? re.join(' & ') : re.join(', ')) + ' is typing...'
            } else {
                text = (contact && contact.lastSeenAt) ? 'Last seen online ' + moment(contact.lastSeenAt).fromNow() : '';
            }

            if (this.lastSeenText !== text) {
                this.lastSeenText = text;
                this.lastSeenKey++;
            }
            if (this.mode === 'messages') {
                setTimeout(() => {
                    this.updateLastSeen()
                }, 300)
            }
        },
        setDimensions() {
            let s = window.innerWidth < 830;
            if (this.disableWideMode !== s) {
                eventBus.$emit('slideover-set-wide-mode-channels', (!s) && this.wideMode);
                this.disableWideMode = s
            }
        }
    },
    async mounted() {
        eventBus.$emit('slideover-set-scrollable-channels', false);
        await User.register()
        User.registerAggregate({
            "type": 'User',
            'id': User.user.id,
            'event': 'ChannelCreated'
        }, this.updateFromUserListener, true)

        this.user = User.user;

        await this.updateMessages()

        let wideChannel = remoteStorage.getItem('messagingWideMode', false, true)
        if (wideChannel) {
            this.wideMode = true;
            eventBus.$emit('slideover-set-wide-mode-channels', this.wideMode);
            let channel = this.channels.find((i) => i.source === wideChannel);
            if (channel) {
                this.viewChannel = channel
            }
        }

        window.Bus.on('close-all-slideovers', (e) => {
            if (e !== '-channels') {
                this.close()
            }
        })

        eventBus.$on('slideover-opened', (e) => {
            if (e !== '-channels') {
                this.close()
            }
        })

        window.Bus.on('show-package-filesystem', () => {
            this.close()
            this.disabledOpening = true;
        });

        window.Bus.on('close-package-filesystem', () => {
            this.disabledOpening = false;
        });

        window.Bus.on('open-messaging', (data) => {
            this.openIt(data)
        });

        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                this.close()
                return
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if (!this.disabledOpening) {
                if ((e.key === 'm') || (e.key === 'M')) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hidden) {
                        this.openIt()
                    } else {
                        this.close()
                    }
                }
            }
        })
        window.Bus.emit('messages-unread', this.unread);
        window.addEventListener('resize', this.setDimensions, true);
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.setDimensions)
        })
        this.updateScrollcontainer();
        window.Bus.emit('message-widget-loaded');
    }
}
</script>
